import React, { Component } from 'react'
import SimpleFormat from 'client/shared/blocks/simple-format'

import './shelf-annotation.styl'

type Props = {
  annotation: string
}

export class ShelfAnnotation extends Component<Props> {
  render(): JSX.Element {
    return (
      <div className="shelf-annotation">
        <SimpleFormat text={this.props.annotation} withLinks />
      </div>
    )
  }
}
